(function () {
	let galleryTextSlide = () => {
		$(".gallery-with-text__card").hover(function () {
			let $this = $(this);
			$this.addClass("active");
			$this.siblings(".gallery-with-text__card").removeClass("active");
			setTimeout(function () {
				$this
					.children(".gallery-with-text__info")
					.children(".link--overlay")
					.addClass("active");
				$this
					.siblings(".gallery-with-text__card")
					.children(".gallery-with-text__info")
					.children(".link--overlay")
					.removeClass("active");
			}, 100);
		});
	};

	document.addEventListener("shopify:section:load", function () {
		galleryTextSlide();
	});

	galleryTextSlide();
})();

$(document).ready(function() {
    $('.gallery-with-text__media').on('focus', 'img', function() {
		console.log('gallery work');
        const cardElement = $(this).closest('.gallery-with-text__media').parent('.gallery-with-text__card');

        if (cardElement.length > 0) {
            cardElement.addClass('active');

            cardElement.siblings('.gallery-with-text__card').removeClass('active');
        }
    });
});
